export function RouteFallback() {
  return (
    <div
      className="min-h-[100dvh] w-full flex items-center justify-center"
      role="status"
      aria-live="polite"
    >
      <div className="h-8 w-8 rounded-full border-2 border-gray-200 border-t-indigo-600 animate-spin" />
      <span className="sr-only">Загрузка…</span>
    </div>
  );
}
